import { useContext } from "react";
import { ApiDataContext } from "../contexts/ApiDataContext";

const useApiData = () => {
    return useContext(ApiDataContext);
}

export default useApiData;